/* global Promise */
import * as R from 'ramda';
import moment from 'moment';
import * as angular from 'angular';

export default function SREditReportScheduleDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  orgDataService,
  reportsDataService
) {
  const vm = this;

  vm.schedule.schedule.monthlyDayOfMonth = vm.schedule.schedule.monthlyDayOfMonth || 1;
  vm.schedule.renderFormat = vm.schedule.renderFormat || vm.schedule.report.renderFormat;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = handleSubmit;
  vm.handleScheduleTimeChange = handleScheduleTimeChange;
  vm.handleEmailRecipientChange = handleEmailRecipientChange;
  vm.handleParameterChange = handleParameterChange;

  vm.minDate = new moment();
  vm.timeIsValid = true;

  _activate();

  function _activate() {

    if (vm.schedule.customerScheduleId > 0) {
      if (vm.schedule.schedule.scheduleType === 1) { // Once
        vm.schedule.schedule.onceExecutionDate = moment(vm.schedule.scheduleParameters.executionDate)
          .format('MM/DD/YYYY');
        vm.minDate = moment(vm.schedule.schedule.onceExecutionDate).format('MM/DD/YYYY');
      } else if (vm.schedule.schedule.scheduleType === 2) { // Weekly
        vm.minDate = moment(vm.schedule.schedule.rangeStartDate).format('MM/DD/YYYY');
      }
    }

    if (!R.isNil(vm.schedule.schedule.executionDate)) {
      vm.executionDate = moment(vm.schedule.schedule.executionDate);
    }

    initializeDefaultParameters();
    initializeSelectedParameters();
  }

  function initializeDefaultParameters() {
    if (vm.schedule.report.scheduleParameters !== null && vm.schedule.report.scheduleParameters !== undefined) {
      vm.schedule.report.scheduleParameters.forEach(parameter => {        
        // Numeric
        if (parameter.parameterDataType === 'numeric') {
          const value = vm.schedule.schedule[`parameter${parameter.scheduleParameterId}Value`];
          if (value === null || value === undefined) {
            vm.schedule.schedule[`parameter${parameter.scheduleParameterId}Value`] = Number(parameter.defaultValue);
          }
        }
      });
    }
  }

  function initializeSelectedParameters() {
    angular.forEach(vm.schedule.report.scheduleParameters, (currentScheduleParam) => {
      if (currentScheduleParam.isMultiSelect) {
        const paramValue = vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`];
        if ((paramValue !== null) && (paramValue !== undefined)) {
          const arr = paramValue.split(',');
          vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`] = arr;
        }
      }

      if (currentScheduleParam.isNumeric) {
        const paramValue = vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`];
        if ((paramValue !== null) && (paramValue !== undefined)) {
          vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`] = Number(paramValue);
        }
      }
    });
  }

  /** ********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    loaderService.showGlobalLoader = true;
    if (_isValid()) {
      _saveSchedule()
        .then(() => {
          loaderService.showGlobalLoader = false;
          alerts.success('The Schedule has been saved successfully.');
          return ssDialogService.hide(
            ssDialogService.dialogs.reports.editReportScheduleDialog
          );
        })
        .catch((err) => {
          loaderService.showGlobalLoader = false;
          alerts.error(err);
        });
    }
  }

  function handleScheduleTimeChange() {
    _timeIsValid();
  }

  function handleEmailRecipientChange() {
    vm.schedule.delivery.emailReport = true;
  }

  function handleParameterChange(scheduleParameter) {
    const value = _getUserValue(scheduleParameter);

    if ((vm.schedule.report.scheduleParameters !== null) && (vm.schedule.report.scheduleParameters !== undefined)) {
      const paramsToUpdate = R.find(R.propEq('dependantUponId', scheduleParameter.scheduleParameterId),
        vm.schedule.report.scheduleParameters);

      if ((paramsToUpdate !== null) && (paramsToUpdate !== undefined)) {
        loaderService.showViewLoader = true;
        reportsDataService.getDependantScheduleValues(
          scheduleParameter.reportGroupId,
          paramsToUpdate.scheduleParameterId,
          value
        ).then((response) => {
          const retParam = response.data;
          vm.schedule.report.scheduleParameters.forEach((param) => {
            if (param.scheduleParameterId === retParam.scheduleParameterId) {
              param.scheduleParameterValues = retParam.scheduleParameterValues;
              param.userValue = '';
              const selectedValuesObj = vm.schedule.report;
              if ((selectedValuesObj !== null) && (selectedValuesObj !== undefined)) {
                const paramSelectedValuesObj = vm.schedule.schedule[`parameter${param.scheduleParameterId}Value`];
                if ((paramSelectedValuesObj !== null) && (paramSelectedValuesObj !== undefined)) {
                  vm.schedule.schedule[`parameter${param.scheduleParameterId}Value`] = '';
                }
              }
            }
          });
          loaderService.showViewLoader = false;
        });
      }
    }
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.editReportScheduleDialog);
  }

  function _getReportParametersFromUI(schedule) {
    const scheduleParameters = schedule.report.scheduleParameters;
    if (R.isEmpty(scheduleParameters) || R.isNil(scheduleParameters)) {
      return null;
    }
    return R.map(
      parameter => ({
        parameterName: parameter.parameterName,
        parameterValue: _getUserValue(parameter)
      }),
      scheduleParameters
    );
  }

  function _getUserValue(parameter) {
    
    // Datetime
    if (parameter.parameterDataType === 'datetime') {
      return moment(parameter.userValue).format('MM/DD/YYYY');
    }

    // Miltiselect
    if (parameter.parameterDataType === 'multiselect') {
      const values = vm.schedule.schedule[`parameter${parameter.scheduleParameterId}Value`];
      if (values.includes('All') === true) {
        return 'All';
      }
      return values.join();
    }

    // Numeric
    if (parameter.parameterDataType === 'numeric') {
      let retVal = null;
      const value = vm.schedule.schedule[`parameter${parameter.scheduleParameterId}Value`];
      if (value !== undefined) {
        retVal = value;
      }
      return retVal;
    }

    return vm.schedule.schedule[`parameter${parameter.scheduleParameterId}Value`];
  }

  function _getScheduleParametersFromUI(schedule) {
    const scheduleParameters = {
      scheduleType: schedule.scheduleType,
    };

    // Execution Time
    scheduleParameters.hour = schedule.executionHour;
    scheduleParameters.minute = schedule.executionMinute;
    scheduleParameters.ampm = schedule.executionAMPM;

    // Recurrence Pattern
    if (schedule.scheduleType === 1) { // Once
      scheduleParameters.executionDate = moment(schedule.onceExecutionDate).format('MM/DD/YYYY');
      vm.schedule.schedule.rangeEndDate = moment(scheduleParameters.executionDate).add(1, 'd').format('MM/DD/YYYY');
    } else if (schedule.scheduleType === 2) { // Weekly
      scheduleParameters.weeklySunday = schedule.weeklySunday || false;
      scheduleParameters.weeklyMonday = schedule.weeklyMonday || false;
      scheduleParameters.weeklyTuesday = schedule.weeklyTuesday || false;
      scheduleParameters.weeklyWednesday = schedule.weeklyWednesday || false;
      scheduleParameters.weeklyThursday = schedule.weeklyThursday || false;
      scheduleParameters.weeklyFriday = schedule.weeklyFriday || false;
      scheduleParameters.weeklySaturday = schedule.weeklySaturday || false;
    } else if (schedule.scheduleType === 3) { // Monthly
      scheduleParameters.monthlyDayOfMonth = schedule.monthlyDayOfMonth;
    }

    // Recurrence Range
    scheduleParameters.rangeStartDate = moment(schedule.rangeStartDate).format('MM/DD/YYYY');

    if (R.isNil(schedule.rangeEndDate)) { // No End Date
      scheduleParameters.rangeEndDate = null;
      scheduleParameters.recurranceType = 1;
    } else { // Has End Date
      scheduleParameters.rangeEndDate = moment(schedule.rangeEndDate).format('MM/DD/YYYY');
      scheduleParameters.recurranceType = 2;
    }

    return scheduleParameters;
  }

  function _saveSchedule() {
    const reportParameters = _getReportParametersFromUI(vm.schedule);
    const scheduleParameters = _getScheduleParametersFromUI(vm.schedule.schedule);

    // Combine the report parameters with the schedule parameters and add them to the schedule itself.
    vm.schedule.submittedParameters = {
      reportParameters,
      scheduleParameters,
    };
    return reportsDataService.saveSchedule(vm.schedule)
      .then((response) => {
        const savedSchedule = response.data;

        if (!savedSchedule || !savedSchedule.customerScheduleId || savedSchedule.customerScheduleId <= 0) {
          // Failure
          return Promise.reject(new Error('Error occurred while saving the Schedule.'));
        }
        // Success
        vm.schedule.customerScheduleId = savedSchedule.customerScheduleId;
        $rootScope.$broadcast('reports.reportScheduleDeleted', { reportGroupId: vm.schedule.reportGroupId, });
        return Promise.resolve();
      });
  }

  function _isValid() {
    let isValid = $scope.srEditReportScheduleForm.$valid;

    if (!isValid) {
      isValid = true;

      if ((($scope.srEditReportScheduleForm.$error.pattern)
        && ($scope.srEditReportScheduleForm.$error.pattern.length > 0))
        || $scope.srEditReportScheduleForm.$error.required) {
        isValid = false;
      }

      if (!_timeIsValid()) {
        isValid = false;
      }
    }

    if (isValid) {
      // One of the report delivery mechanisms must be in place
      if ((!vm.schedule.delivery.saveToInstitutionReports)
          && (!vm.schedule.delivery.saveToMyReports)
          && (!vm.schedule.delivery.emailReport)) {
        isValid = false;
        alerts.error('A delivery mechanism must be chosen.');
      }
    }

    if (isValid) {
      // One of the report delivery mechanisms must be in place
      if ((vm.schedule.delivery.emailReport) && (vm.schedule.delivery.emailRecipients.length === 0)) {
        isValid = false;
        alerts.error('Email recipients must be chosen when the "Email Report" delivery method is chosen.');
      }
    }

    return isValid;
  }

  function _timeIsValid() {
    let isValid = true;
    const date = '12/23/1973 ';
    const generationStartTime = vm.schedule.blackoutUntil === null ? '00:00:00' : vm.schedule.blackoutUntil;
    let hour = 11;
    let minute = 59;

    if (!R.isNil(vm.schedule.schedule.executionHour)) {
      hour = vm.schedule.schedule.executionHour;
    }

    if (!R.isNil(vm.schedule.schedule.executionMinute)) {
      minute = vm.schedule.schedule.executionMinute;
    }

    if (!R.isNil(vm.schedule.schedule.executionAMPM)) {
      if (vm.schedule.schedule.executionAMPM === '1') {
        hour += 12;
      }
    }

    const earliestExecutionTime = moment(date + generationStartTime);
    const execTime = `${date + hour}:${minute}:00`;
    const currentExecutionTime = moment(execTime);

    if (currentExecutionTime < earliestExecutionTime) {
      isValid = false;
    }
    vm.timeIsValid = isValid;
    return isValid;
  }
}

SREditReportScheduleDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'alerts',
  'ssDialogService',
  'loaderService',
  'orgDataService',
  'reportsDataService',
];
